import { combineReducers } from 'redux';

import identityInfoForm from './identityInfoForm';
import loginForm from './loginForm';
import organizations from './organizations';
import otpForm from './otpForm';
import userInfo from './userInfo';
import lockdown from './lockdown';
import login from './login';

export default combineReducers({
  identityInfoForm,
  loginForm,
  organizations,
  otpForm,
  userInfo,
  lockdown,
  login,
});
